
<div class="order-changes-toast" :class="toastConfig.className">
    <div class="order-changes-toast__content">
        <b-avatar
            size="16px"
            class="order-changes-toast__icon mr-75 flex-shrink-0"
        >
            <img
                width="16"
                height="16"
                :src="toastConfig.icon"
                :alt="type"
            />
        </b-avatar>
        <div class="order-changes-toast__text">
            <p>{{ changes }}</p>
            <button
                class="order-changes-toast__action"
                @click="handleOpenOrder"
            >
                <span :style="`color: ${toastConfig.textColor}`"
                    >Просмотреть изменения</span
                >
            </button>
        </div>
        <span
            class="cursor-pointer toastification-close-icon ml-auto"
            @click="$emit('close-toast')"
        >
            <feather-icon
                v-if="!hideClose"
                size="18"
                icon="XIcon"
                class="mb-2"
            />
        </span>
    </div>
</div>
